<template>
  <div class="echarts">
    <div class="box" :style="{width:'100%'}" ref="myEchart"></div>
  </div>
</template>

<script>
  import '../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
  export default {
    name: "echarts",
    props: {
      mapData: {
        type: Array,
      }
    },
    data() {
      return {};
    },
    watch: {
      mapData(val) {
        console.log(11111);
        this.chinaConfigure();
      }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
      chinaConfigure() {
        let myChart = this.$echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置
        window.onresize = myChart.resize;
        myChart.setOption({ // 进行相关配置
          backgroundColor: "#fff",
          tooltip: {
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
          }, // 鼠标移到图里面的浮动提示框
          dataRange: {
            show: false,
            min: 0,
            max: 1000,
            text: ['High', 'Low'],
            realtime: true,
            calculable: true,
            color: ['#006ec7', '#ffffff'],
          },
          geo: { // 这个是重点配置区
            map: 'china', // 表示中国地图
            roam: true,
            label: {
              normal: {
                show: false, // 是否显示对应地名
                textStyle: {
                  color: 'rgba(0,0,0,0.4)'
                }
              },
              emphasis: {
                color: "#ffffff"
              }
            },
            itemStyle: {
              normal: {
                borderColor: 'rgba(0, 0, 0, 0.2)'
              },
              emphasis: {
                areaColor: "#1F89DF",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 0,
                borderWidth: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          },
          series: [{
            type: 'scatter',
            coordinateSystem: 'geo', // 对应上方配置
            roam: false
          },
            {
              name: '人数', // 浮动框的标题
              type: 'map',
              geoIndex: 0,
              data: this.mapData
            }
          ]
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .echarts
    width 100%
    height 100%

    .box
      width 100%
      height 100%
</style>



// WEBPACK FOOTER //
// src/components/datanalysis/map.vue